import { useSeo } from "@/lib/seo";
import { PageHeader, Section } from "@/components/blocks";
import { Placeholder } from "@/components/Placeholder";

const Block = ({ title, children }) => (
  <div className="border-b border-[#0B0A08]/10 py-8 last:border-b-0">
    <h2 className="font-serif text-xl tracking-tight">{title}</h2>
    <div className="prose-editorial mt-3 space-y-3 text-sm">{children}</div>
  </div>
);

export default function Terms() {
  useSeo({
    title: "Terms of Service — Nanny Poppins UAE",
    description: "The terms that apply when you use the Nanny Poppins website and forms.",
  });

  return (
    <div>
      <PageHeader eyebrow="Terms of Service" title="The basics of using this site." />
      <Section className="max-w-3xl">
        <p className="text-sm text-[#0B0A08]/55">
          Last updated: <Placeholder>To be confirmed</Placeholder>
        </p>

        <Block title="About these terms">
          <p>
            By using this website and submitting a form, you agree to these terms. This site is operated by{" "}
            <Placeholder>Legal entity name — to be confirmed</Placeholder>.
          </p>
        </Block>

        <Block title="Our service">
          <p>
            Nanny Poppins is a nanny-matching service. We introduce families and nannies where we believe
            there may be a good fit. We do not employ nannies on your behalf, and we do not provide cleaning,
            visa, immigration or payroll services.
          </p>
        </Block>

        <Block title="No guarantees">
          <p>
            We make no guarantee that a match will be found, nor any promise about response times or outcomes.
            Any decision to engage a nanny is made by you.
          </p>
        </Block>

        <Block title="Accurate information">
          <p>
            You agree to provide accurate information and to only submit details you are permitted to share.
            Please do not submit sensitive documents such as passports, Emirates IDs or bank details through
            public forms.
          </p>
        </Block>

        <Block title="Fees">
          <p>
            We don't publish standard prices. The team will discuss fees after understanding the family's
            needs. Any applicable fees will be agreed with you directly.
          </p>
        </Block>

        <Block title="Changes">
          <p>
            We may update these terms as our service develops. Material changes will be reflected on this page.
            Questions? <Placeholder>Contact details — coming soon</Placeholder>.
          </p>
        </Block>
      </Section>
    </div>
  );
}
